(function () {
  if (window.dscLanding) return;
  window.dscLanding = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);
  var observer = null;

  if (!reduceMotion && !designMode && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function initReveal(scope) {
    if (!observer || !scope) return;
    var pages = scope.matches && scope.matches('[data-dsc-page]') ? [scope] : scope.querySelectorAll('[data-dsc-page]');
    Array.prototype.forEach.call(pages, function (page) {
      if (page.classList.contains('dsc-motion')) return;
      page.classList.add('dsc-motion');
      page.querySelectorAll('[data-dsc-reveal]').forEach(function (item) { observer.observe(item); });
    });
  }

  function openLightbox(dialog, content, ratio, label, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    var stage = dialog.querySelector('[data-dsc-lightbox-stage]');
    stage.replaceChildren(content);
    stage.style.setProperty('--dsc-ratio', ratio);
    dialog.setAttribute('aria-label', label);
    dialog.classList.toggle('dsc-lightbox--image', content.tagName === 'IMG');
    dialog.dscTrigger = trigger;

    if (!dialog.dscBound) {
      dialog.dscBound = true;
      dialog.addEventListener('close', function () {
        stage.replaceChildren();
        document.documentElement.style.overflow = '';
        if (dialog.dscTrigger) dialog.dscTrigger.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('[data-dsc-lightbox-close]')) dialog.close();
      });
    }

    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    return true;
  }

  function vimeoFrame(link) {
    var frame = document.createElement('iframe');
    var hash = link.dataset.dscVimeoHash ? '&h=' + link.dataset.dscVimeoHash : '';
    frame.src = 'https://player.vimeo.com/video/' + link.dataset.dscVimeoId +
      '?autoplay=1&dnt=1&title=0&byline=0&portrait=0' + hash;
    frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    frame.allowFullscreen = true;
    return frame;
  }

  function shopifyVideo(link) {
    var template = link.parentElement.querySelector('template[data-dsc-video-template]');
    if (!template) return null;
    var video = template.content.querySelector('video');
    return video ? video.cloneNode(true) : null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-dsc-video], [data-dsc-zoom]');
    if (!link) return;
    var page = link.closest('[data-dsc-page]');
    var dialog = page && page.querySelector('[data-dsc-lightbox]');
    if (!dialog) return;

    var label = link.dataset.dscLabel || link.getAttribute('aria-label') || '';
    var content = null;
    var ratio = link.dataset.dscRatio || 1;

    if (link.hasAttribute('data-dsc-zoom')) {
      content = document.createElement('img');
      content.src = link.getAttribute('href');
      content.alt = link.dataset.dscAlt || '';
    } else if (link.dataset.dscVideo === 'vimeo' && link.dataset.dscVimeoId) {
      content = vimeoFrame(link);
      content.title = label;
    } else if (link.dataset.dscVideo === 'shopify') {
      content = shopifyVideo(link);
    }

    if (content && openLightbox(dialog, content, ratio, label, link)) {
      event.preventDefault();
      if (content.tagName === 'VIDEO') {
        var playing = content.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    }
  });

  var thumbObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      thumbObserver.unobserve(entry.target);
      loadVimeoThumb(entry.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function applyThumb(link, src) {
    var holder = link.querySelector('[data-dsc-auto-thumb]');
    if (!holder) return;
    var img = new Image();
    img.className = 'dsc-testimonials__video-image dsc-testimonials__video-image--auto';
    img.alt = '';
    img.decoding = 'async';
    img.onload = function () { if (holder.isConnected) holder.replaceWith(img); };
    img.src = src;
  }

  function loadVimeoThumb(link) {
    var url = link.getAttribute('href');
    if (!url || url === '#') return;
    var width = Math.min(1280, Math.ceil(link.offsetWidth * (window.devicePixelRatio || 1) / 160) * 160) || 960;
    var key = 'dsc-vimeo-thumb:' + width + ':' + url;
    var cached = null;
    try { cached = window.sessionStorage.getItem(key); } catch (error) {}
    if (cached) {
      applyThumb(link, cached);
      return;
    }
    fetch('https://vimeo.com/api/oembed.json?width=' + width + '&url=' + encodeURIComponent(url))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.thumbnail_url) return;
        try { window.sessionStorage.setItem(key, data.thumbnail_url); } catch (error) {}
        applyThumb(link, data.thumbnail_url);
      })
      .catch(function () {});
  }

  function initThumbs(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-dsc-video="vimeo"]').forEach(function (link) {
      if (link.dscThumbQueued || !link.querySelector('[data-dsc-auto-thumb]')) return;
      link.dscThumbQueued = true;
      if (thumbObserver) thumbObserver.observe(link);
      else loadVimeoThumb(link);
    });
  }

  function prepareAccordion(list) {
    if (list.dscReady) return;
    list.dscReady = true;
    list.querySelectorAll('details[name]').forEach(function (item) {
      item.dataset.dscGroup = item.getAttribute('name');
      item.removeAttribute('name');
    });
  }

  function setItem(item, open) {
    var summary = item.querySelector('summary');
    var answer = item.querySelector('.dsc-faq__answer');
    var startHeight = item.offsetHeight;

    if (item.dscAnimation) item.dscAnimation.cancel();
    if (item.dscFade) item.dscFade.cancel();
    item.dscTarget = open;

    if (reduceMotion || typeof item.animate !== 'function') {
      item.dscAnimation = null;
      item.open = open;
      return;
    }

    if (open) item.open = true;
    var endHeight = open ? item.offsetHeight : summary.offsetHeight + (item.offsetHeight - item.clientHeight);

    item.style.overflow = 'hidden';
    item.dscAnimation = item.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: 380, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
    );
    if (answer) {
      item.dscFade = answer.animate(
        open ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0, offset: 0.6 }, { opacity: 0 }],
        { duration: 380, easing: 'ease-out' }
      );
    }

    var animation = item.dscAnimation;
    animation.onfinish = function () {
      if (item.dscAnimation !== animation) return;
      item.dscAnimation = null;
      item.style.overflow = '';
      if (!open) item.open = false;
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.dsc-faq__question');
    var item = summary && summary.parentElement;
    var list = item && item.closest('.dsc-faq__list');
    if (!list || item.tagName !== 'DETAILS') return;

    event.preventDefault();
    prepareAccordion(list);
    var open = item.dscAnimation ? !item.dscTarget : !item.open;

    if (open && item.dataset.dscGroup) {
      list.querySelectorAll('details[data-dsc-group]').forEach(function (other) {
        if (other === item || other.dataset.dscGroup !== item.dataset.dscGroup) return;
        if (other.dscAnimation ? other.dscTarget : other.open) setItem(other, false);
      });
    }
    setItem(item, open);
  });

  function setBusy(button, busy) {
    button.classList.toggle('is-loading', busy);
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function goToCheckout(button) {
    var variantId = Number(button.dataset.dscCheckout);
    var cartUrl = button.dataset.dscCartUrl || '/cart';
    var addUrl = button.dataset.dscCartAddUrl || '/cart/add';
    var checkoutUrl = button.dataset.dscCheckoutUrl || '/checkout';
    var fallbackUrl = button.dataset.dscProductUrl || button.getAttribute('href');

    setBusy(button, true);

    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (item) { return item.variant_id === variantId; });
        if (inCart) return null;
        return fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function (response) {
          if (!response.ok) throw new Error('add');
        });
      })
      .then(function () {
        window.location.href = checkoutUrl;
      })
      .catch(function () {
        setBusy(button, false);
        window.location.href = fallbackUrl;
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dsc-checkout]');
    if (!button || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    goToCheckout(button);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-dsc-checkout][aria-busy]').forEach(function (button) { setBusy(button, false); });
  });

  function start() {
    initReveal(document);
    initThumbs(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
    initThumbs(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target.tagName === 'DETAILS') event.target.open = true;
  });
})();
